import React from 'react';
import { useNavigate } from 'react-router-dom';
import './BattingStats.css';

const BattingStats = ({ players }) => {
  const navigate = useNavigate();

  if (!players || players.length === 0) {
    return <div className="no-data">No batting statistics available</div>;
  }

  const handlePlayerClick = (playerName) => {
    navigate(`/player/${encodeURIComponent(playerName)}/batting`);
  };

  return (
    <div className="stats-table-container">
      <table className="stats-table">
        <thead>
          <tr>
            <th className="col-rank">#</th>
            <th className="col-name">Player</th>
            <th className="col-matches">M</th>
            <th className="col-innings">I</th>
            <th className="col-runs">Runs</th>
            <th className="col-balls">Balls</th>
            <th className="col-avg">Avg</th>
            <th className="col-sr">SR</th>
            <th className="col-hs">HS</th>
            <th className="col-fours">4s</th>
            <th className="col-sixes">6s</th>
          </tr>
        </thead>
        <tbody>
          {players.map((player, index) => (
            <tr key={`${player.playerName}-${index}`} className={index % 2 === 0 ? 'even' : 'odd'}>
              <td className="col-rank">{index + 1}</td>
              <td 
                className="col-name clickable"
                onClick={() => handlePlayerClick(player.playerName)}
              >
                <span className="player-name">{player.playerName}</span>
              </td>
              <td className="col-matches">{player.matches}</td>
              <td className="col-innings">{player.innings}</td>
              <td className="col-runs">
                <span className="stat-value runs">{player.runs}</span>
              </td>
              <td className="col-balls">{player.balls}</td>
              <td className="col-avg">{player.avg}</td>
              <td className="col-sr">{player.sr}</td>
              <td className="col-hs">{player.hs}</td>
              <td className="col-fours">{player.fours}</td>
              <td className="col-sixes">{player.sixes}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BattingStats;
